import axios from 'axios'
import Website from "@/config/website";
axios.defaults.withCredentials = true

const baseURL = process.env.VUE_APP_URL + Website.apiPrefix;
// 开发环境下打印API配置，便于调试
if (process.env.NODE_ENV === 'development') {
  console.log('API配置:', {
    VUE_APP_URL: process.env.VUE_APP_URL,
    apiPrefix: Website.apiPrefix,
    baseURL: baseURL
  });
}

const api = axios.create({
  baseURL: baseURL,
  timeout: 20 * 1000,
});
// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
api.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json;charset=utf-8';

  // config.headers['token'] = user.token;  // 设置请求头
  return config
}, error => {
  return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
api.interceptors.response.use(
  response => {
    let res = response.data;
    // 如果是返回的文件
    if (response.config.responseType === 'blob') {
      return res
    }
    // 兼容服务端返回的字符串数据
    if (typeof res === 'string') {
      // 检查是否是HTML响应（通常是API地址配置错误）
      if (res.trim().startsWith('<!') || res.trim().startsWith('<html')) {
        console.error('API返回了HTML而不是JSON，请检查API地址配置:', response.config.url);
        return Promise.reject(new Error('API地址配置错误，返回了HTML页面'))
      }
      try {
        res = res ? JSON.parse(res) : res
      } catch (e) {
        console.error('JSON解析失败:', e, '响应内容:', res.substring(0, 200));
        return Promise.reject(new Error('响应数据格式错误'))
      }
    }
    return res;
  },
  error => {
    // 处理网络错误或HTTP错误
    if (error.response) {
      // 服务器返回了错误状态码
      const status = error.response.status;
      const data = error.response.data;
      
      // 如果返回的是HTML，说明API地址可能配置错误
      if (typeof data === 'string' && (data.trim().startsWith('<!') || data.trim().startsWith('<html'))) {
        console.error('API返回了HTML页面，请检查API地址配置:', error.config?.url);
        console.error('当前API基础地址:', process.env.VUE_APP_URL);
        return Promise.reject(new Error('API地址配置错误，请检查VUE_APP_URL环境变量'))
      }
      
      console.error('API请求失败:', status, data);
    } else if (error.request) {
      // 请求已发出但没有收到响应
      console.error('API请求无响应，请检查服务是否启动:', error.config?.url);
      console.error('当前API基础地址:', process.env.VUE_APP_URL);
    } else {
      // 其他错误
      console.error('API请求错误:', error.message);
    }
    return Promise.reject(error)
  }
)

export default api
